module.exports = __webpack_public_path__ + "img/u97.90b4ada.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/clay/u97.png
// module id = 8deC
// module chunks = 0